import { RouteConfig } from 'vue-router';

const XtkList = () => import(/* webpackChunkName: "Jxgl" */  './module/xtk/xtk-list/xtk-list.vue');
const XtkDetail = () => import(/* webpackChunkName: "Jxgl" */  './module/xtk/xkt-detail.vue');
const SjkList = () => import(/* webpackChunkName: "Jxgl" */  './module/sjk/sjk-list.vue');
const SjkDetail = () => import(/* webpackChunkName: "Jxgl" */  './module/sjk/sjk-detail/sjk-detail.vue');
const SjkPreview = () => import(/* webpackChunkName: "Jxgl" */  './module/sjk/sjk-preview/sjk-preview.vue');
const BjglList = () => import(/* webpackChunkName: "Jxgl" */  './module/bjgl/bjgl-list/bjgl-list.vue');
const XsDetail = () => import(/* webpackChunkName: "Jxgl" */  './module/bjgl/xs-detail.vue');
const KsglList = () => import(/* webpackChunkName: "Jxgl" */  './module/ksgl/ksgl-list/ksgl-list.vue');
const KsglDetail = () => import(/* webpackChunkName: "Jxgl" */  './module/ksgl/ksgl-detail.vue');
const KsglResultList = () => import(/* webpackChunkName: "Jxgl" */  './module/ksgl/ksgl-result-list/ksgl-result-list.vue');
const KsglAnalysis = () => import(/* webpackChunkName: "Jxgl" */  './module/ksgl/ksgl-analysis/ksgl-analysis.vue');


const routers: RouteConfig[] = [
    {
        path: 'xtk-list',
        component: XtkList
    },
    {
        path: 'xtk-detail',
        component: XtkDetail
    },
    {
        path: 'sjk-list',
        component: SjkList
    },
    {
        path: 'sjk-detail',
        component: SjkDetail
    },
    {
        path: 'sjk-preview',
        component: SjkPreview
    },
    {
        path: 'bjgl-list',
        component: BjglList
    },
    {
        path: 'xs-detail',
        component: XsDetail
    },
    {
        path: 'ksgl-list',
        component: KsglList
    },
    {
        path: 'ksgl-detail',
        component: KsglDetail
    },
    {
        path: 'ksgl-result-list',
        component: KsglResultList
    },
    {
        path: 'ksgl-analysis',
        component: KsglAnalysis
    },
    {
        path: '',
        redirect: 'xtk-list'
    },
];

export default routers;
